import React, { useState } from 'react';
import { db } from '../firebase'; 
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import './Guestbook.css'; 

const WriteWish = () => {
  const [name, setName] = useState('');
  const [note, setNote] = useState('');
  const [showConfetti, setShowConfetti] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !note.trim()) return;
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, 'messages'), {
        name: name,
        text: note,
        createdAt: Timestamp.now()
      });
      
      setShowConfetti(true);
      
      setTimeout(() => {
        navigate('/wishes');
      }, 3500);
      
    } catch (error) {
      console.error("Error adding message: ", error);
      alert("Could not send message. Please try again.");
      setIsSubmitting(false);
    }
  };

  if (showConfetti) {
    return (
      <div className="guestbook-container">
        <Confetti numberOfPieces={400} recycle={false} gravity={0.15} />
        <div className="success-message">
          <div className="success-icon">💌</div>
          <h1>Wishes Sent!</h1>
          <p>Koralie is going to love your message. Redirecting you...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="guestbook-container">
      <div className="guestbook-header">
        <span className="header-icon">✍️</span>
        <h1>Sign the Wall</h1>
        <p>Your message will appear on Koralie's birthday wall.</p>
      </div>

      <div className="write-layout">
        {/* THE FORM */}
        <form onSubmit={handleSubmit} className="guestbook-form premium-form">
          <div className="form-group">
            <label>Your Name</label>
            <input 
              type="text" 
              placeholder="e.g. Aunt Sarah" 
              value={name} 
              onChange={e => setName(e.target.value)} 
              maxLength="30"
              required 
            />
          </div>
          <div className="form-group">
            <label>Your Message</label>
            <textarea 
              placeholder="Write something sweet..." 
              value={note} 
              onChange={e => setNote(e.target.value)} 
              maxLength="1000"
              required 
              rows="5"
            ></textarea>
            <small className="char-count">{note.length} / 1000</small>
          </div>
          <button type="submit" disabled={isSubmitting} className="submit-btn">
            {isSubmitting ? "Sending..." : "Post to Wish Wall"}
          </button>
        </form>

        {/* LIVE PREVIEW - Makes it feel high-end */}
        <div className="preview-section">
          <h3>Live Preview</h3>
          <div className="message-card preview-card">
            <div className="card-decoration">✨</div>
            <p className="message-text">
              {note || "Your message will look like this..."}
            </p>
            <div className="card-footer">
              <h4 className="message-author">{name || "Your Name"}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WriteWish;